// extracted by mini-css-extract-plugin
export default {"overlay":"VideoDialog_overlay__yzBah","holder":"VideoDialog_holder__5qmog","dialog":"VideoDialog_dialog__ha4LF","close":"VideoDialog_close__soMBy"};